import { createSceneReducer } from 'reducers/reducers-util';
import contractorsInvoicesDataReducer from 'components/admin/contractors-invoices/store/reducers.data';
import contractorsInvoicesUiReducer from 'components/admin/contractors-invoices/store/reducers.ui';

export default createSceneReducer(
  contractorsInvoicesDataReducer,
  contractorsInvoicesUiReducer
);
